import React, { useEffect, useState } from "react";
import ApexCharts from "apexcharts";
import jsonData from "../../../../current-survey-numeric.json";
import { FILTER_CONFIG } from "../../../../config/filterconfig"; // Import the centralized config

const D01BarChartViz04 = ({ filterCriteria }) => {
  const [categories, setCategories] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    // Helper function to map filter keys to JSON keys
    const getJsonKey = (filterKey) => {
      const config = FILTER_CONFIG.find((item) => item.fieldName === filterKey);
      return config ? config.jsonKey : filterKey; // Default to the key if no mapping is found
    };

    // Apply filtering logic based on `filterCriteria`
    const filterData = (item) => {
      return Object.keys(filterCriteria).every((key) => {
        const jsonKey = getJsonKey(key); // Map filter key to JSON field
        if (filterCriteria[key].length === 0) {
          return true; // If no filter is selected, include all items
        }
        return filterCriteria[key].includes(item[jsonKey]);
      });
    };

    // Filter data using the filter criteria
    const filteredData = jsonData.filter(filterData);

    // Aggregate data by job class code (demographic_category_04 in the new JSON)
    const jobClassCodeCounts = filteredData.reduce((acc, item) => {
      const jobClassCode = item.demographic_category_04; // Use demographic_category_04 for Job Class Code
      if (!acc[jobClassCode]) {
        acc[jobClassCode] = 0;
      }
      acc[jobClassCode]++;
      return acc;
    }, {});

    // Sort job class code names alphabetically
    const jobClassCodeNames = Object.keys(jobClassCodeCounts).sort((a, b) =>
      a.localeCompare(b)
    );
    const chartData = jobClassCodeNames.map(
      (jobClassCode) => jobClassCodeCounts[jobClassCode]
    );

    // Update state
    setCategories(jobClassCodeNames);
    setData(chartData);

    // Chart height calculation
    const barHeight = 25;
    const minBars = 10;
    const chartHeight = Math.max(
      barHeight * jobClassCodeNames.length,
      barHeight * minBars
    );

    // Chart options
    const optionsViz04 = {
      series: [
        {
          name: "Count",
          data: chartData,
        },
      ],
      colors: ["#004983"],
      chart: {
        type: "bar",
        height: chartHeight,
        width: "95%",
      },
      legend: {
        show: false,
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          borderRadiusApplication: "end",
          horizontal: true,
          distributed: false,
          barHeight: "22.5px",
          dataLabels: {
            position: "top",
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetX: 20, // Move labels off the bars
        style: {
          colors: ["#000"], // Set data labels to black
        },
        dropShadow: {
          enabled: true,
          top: 0,
          left: 0,
          blur: 2.5,
          color: "#fff",
          opacity: 1,
        },
      },
      xaxis: {
        categories: jobClassCodeNames,
      },
    };

    // Render the chart
    const viz04 = new ApexCharts(
      document.querySelector("#viz-04"),
      optionsViz04
    );
    viz04.render();

    // Cleanup chart on component unmount
    return () => {
      viz04.destroy();
    };
  }, [filterCriteria]);

  return (
    <div style={{ width: "100%", overflowY: "auto", maxHeight: "450px" }}>
      <div id="viz-04"></div>
    </div>
  );
};

export default D01BarChartViz04;
